export default __webpack_public_path__ + "static/media/no-image.d8fafb4f.jpg";